var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "messenger_svg2__a",
    x1: 13.5,
    x2: 147.6,
    y1: 179.9,
    y2: 48.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#messenger_svg2__a",
    id: "messenger_svg2__b",
    x1: 14.8,
    x2: 148.8,
    y1: 181.2,
    y2: 50.1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 4.7C44.6 4.7 0 45.5 0 95.3s10.4 46.1 27.5 62.4l-4.1 29.6c-.4 2.6.7 5.1 2.8 6.6s4.9 1.7 7.2.6l29.8-14.9C74.6 183.7 87 186 100 186c55.4 0 100-40.9 100-90.7S155.4 4.7 100 4.7m0 167.4c-12.3 0-24-2.3-34.7-6.5-1.8-.7-3.9-.6-5.7.3l-20.7 10.3 2.8-20.1c.3-2.3-.5-4.7-2.3-6.2-15.7-13.9-25.5-33.2-25.5-54.5 0-42.6 38.7-76.7 86-76.7s86 34.2 86 76.7-38.7 76.7-86 76.7Z",
    style: {
      fill: "url(#messenger_svg2__a)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7 70.7c-8.5 4.7-20.3 11.3-26.8 14.9-3 1.7-6.8 1.5-9.7-.4-4.2-2.8-10.4-6.9-15.3-10.2-2.1-1.4-4.6-1.9-7.1-1.4-2.4.5-4.6 2-5.9 4.1C74 88.5 61.5 107.9 53 121.1c-.7 1.1-.5 2.7.5 3.6s2.5 1 3.6.1c8.1-6.3 18.2-14.1 24-18.7 3-2.3 7.1-2.6 10.3-.7 5.4 3.1 13.6 7.8 19.6 11.2 4.2 2.4 9.6 1.2 12.4-2.9 6.6-10 18.6-27.9 26-39 .7-1.1.6-2.5-.3-3.4s-2.3-1.2-3.4-.5Z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0,
      fill: "url(#messenger_svg2__b)"
    }
  }));
};
export default SvgMessenger;